import { Variant } from '../../../Variant/Variant';
import styles from './ClassicQuiz.module.css';
import { motion } from 'motion/react';

export const ClassicQuiz = ({ variants, isStateCorrectVar, initDelay }) => {
  return (
    <motion.div className={styles.variantsContainer}>
      {variants?.map((item, i) => (
        <Variant
          key={item.coment + String(i)}
          item={item}
          index={i}
          aciveAmimate={isStateCorrectVar && item.correct}
          isStateCorrectVar={isStateCorrectVar}
          delayVariant={i * 0.5 + 2 + initDelay}
        />
      ))}
    </motion.div>
  );
};
